import React, { useEffect, useState } from 'react';
import OTPInput from './vtotp';
import { MediumBody, SemiboldBody } from '../../../components/core/typography';
import { LargePrimaryButton } from '../../../components/core/buttons';
import { resendCode } from '../../../services/api';
import { message } from 'antd';
import { getIcon } from '../../../components/core/vticon';

interface NewLoginProps {
	email: string;
	verifyCode: any;
	setStep: any;
}

const NewUserLogin: React.FC<NewLoginProps> = ({ email, verifyCode, setStep }) => {
	const [otpValues, setOtpValues] = useState(Array(6).fill(''));
	const [enableResend, setEnableResend] = useState(true);
	const [count, setCount] = useState(30);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	// Initialize timer as null
	let timer: NodeJS.Timeout | null = null;

	// Wrapper function to convert string to array
	const handleOtpChange = (value: string) => {
		setOtpValues(value.split(''));
	};

	useEffect(() => {
		if (count > 0) {
			timer = setInterval(() => {
				setCount((prevCount) => prevCount - 1);
			}, 1000);
		} else {
			setEnableResend(true);
			if (timer) {
				clearInterval(timer); 
			}
		}	return () => {
			if (timer) {
				clearInterval(timer);
			}
		};
	}, [count]);

	const handleLoginClick = async () => {
		try {
			setIsLoading(true);
			setErrorMessage('');
			const response = await verifyCode({
				email: email,
				verification_code: otpValues.join(''),
			});
			console.log("response", response)
			if (!response.success && response.message) {
				setErrorMessage( response?.message || "Invalid verification code provided, please try again.");
				setOtpValues(Array(6).fill(''));
			}
		} catch (errorInfo: any) {
			console.log('Validation Failed:', errorInfo?.message);
			const errorMsg = errorInfo?.message || 'Failed to verify code. Please try again.';
			setErrorMessage(errorMsg);
			setOtpValues(Array(6).fill(''));
		} finally {
			setIsLoading(false);
		}
	};

	const handleResend = async () => {
		try {
			if (enableResend) {
				const res = await resendCode({ email: email });
				if (res.success) {
					message.success(res.message);
					setEnableResend(false);
					setCount(30);
				} else if (res.error) {
					message.error(res.message);
				}
			}
		} catch (errorInfo) {
			console.log('Resend Failed:', errorInfo);
		}
	};

	return (
		<div className="w-full">
			<OTPInput length={6} otpValues={otpValues.join('')} setOtpValues={handleOtpChange} onEnter={handleLoginClick} />
			<div className='mt-4 lg:mt-[16px] flex flex-col sm:flex-row gap-1 text-center sm:text-left'>
				<MediumBody text={'Did not receive the code?'} color='#667085' />
				<div className={enableResend ? `cursor-pointer` : 'cursor-not-allowed'} onClick={handleResend}>
					<SemiboldBody
						text={enableResend ? 'Resend' : `Resend in ${count} seconds`}
						color={enableResend ? '#7F56D9' : '#667085'}
					/>
				</div>
			</div>

			{errorMessage && (
				<div className='mt-4 text-center'>
					<div className='flex items-center justify-center text-red-500'>
						{errorMessage}
					</div>
				</div>
			)}

			<div className='w-full mt-8 lg:mt-[40px]'>
				<LargePrimaryButton loading={isLoading} text={'Log in'} handleClick={() => handleLoginClick()} style={{ width: '100%' }} />
			</div>
			<div
				className='mt-8 lg:mt-[32px] cursor-pointer w-full flex items-center justify-center gap-2'
				onClick={() => setStep(1)}
			>
				{getIcon('ArrowLeft', 20, 20, '#475467')}
				<SemiboldBody text={'Back to log in'} color='#475467' />
			</div>
		</div>
	);
};

export default NewUserLogin;
